import { createFileRoute } from "@tanstack/react-router";
import { PoliciesAndDocumentsPage } from "../../pages/dashboard/policies-and-documents/PoliciesAndDocuments.page";

export const Route = createFileRoute("/_protected/dashboard/policies-and-documents")({
  component: PoliciesAndDocumentsPage,
});
